(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["r3-video-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('r3-hero-player')) {
  customElements.define('r3-hero-player', class extends HTMLElement {
    connectedCallback() {
      if (this.cleanup) return;
      const video = this.querySelector('video');
      const button = this.querySelector('button');
      if (!video || !button) return;
      const controller = new AbortController();
      const options = { signal: controller.signal };
      const motion = matchMedia('(prefers-reduced-motion: reduce)');
      let visible = false;
      let pending = false;
      video.muted = true;
      video.defaultMuted = true;
      const play = () => {
        if (motion.matches || document.hidden || pending || !video.paused) return;
        pending = true;
        video.play().catch(() => { button.hidden = false; }).finally(() => { pending = false; });
      };
      const syncMotion = () => {
        video.autoplay = !motion.matches;
        if (motion.matches) { video.pause(); button.hidden = true; }
        else if (visible) play();
      };
      video.addEventListener('playing', () => { button.hidden = true; }, options);
      video.addEventListener('pause', () => { button.hidden = motion.matches; }, options);
      video.addEventListener('error', () => { button.hidden = motion.matches; }, options);
      button.addEventListener('click', play, options);
      motion.addEventListener('change', syncMotion, options);
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) video.pause();
        else if (visible) play();
      }, options);
      const observer = new IntersectionObserver(([entry]) => {
        visible = entry.isIntersecting;
        if (visible) play();
        else video.pause();
      });
      observer.observe(this);
      syncMotion();
      this.cleanup = () => { controller.abort(); observer.disconnect(); video.pause(); };
    }
    disconnectedCallback() { this.cleanup?.(); this.cleanup = null; }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["welcome-offer-popup"]) return;
  try {
    
  class WelcomeOffer extends HTMLElement {
    connectedCallback() {
      this.storageKey = 'resistanc3-welcome-offer';
      this.closeButtons = this.querySelectorAll('[data-welcome-offer-close]');
      this.closeButtons.forEach((button) => button.addEventListener('click', this.close));
      document.addEventListener('keydown', this.handleKeydown);

      if (this.dataset.success === 'true') {
        this.remember(365);
        this.show();
        window.setTimeout(this.removePanel, 5000);
        return;
      }

      if (this.dataset.errors === 'true' || this.dataset.designMode === 'true') {
        this.show();
        return;
      }

      if (this.isDismissed()) {
        this.removePanel();
        return;
      }

      const delay = Math.max(0, Number(this.dataset.delaySeconds) || 0) * 1000;
      this.timer = window.setTimeout(this.show, delay);
    }

    disconnectedCallback() {
      window.clearTimeout(this.timer);
      document.removeEventListener('keydown', this.handleKeydown);
    }

    show = () => {
      this.hidden = false;
    };

    close = () => {
      this.remember(Number(this.dataset.dismissDays) || 30);
      this.removePanel();
    };

    removePanel = () => {
      this.hidden = true;
      this.style.pointerEvents = 'none';
      window.clearTimeout(this.timer);
      window.requestAnimationFrame(() => this.remove());
    };

    handleKeydown = (event) => {
      if (event.key === 'Escape' && !this.hidden) this.close();
    };

    isDismissed() {
      try {
        const expiresAt = Number(window.localStorage.getItem(this.storageKey));
        return Number.isFinite(expiresAt) && expiresAt > Date.now();
      } catch {
        return false;
      }
    }

    remember(days) {
      try {
        const expiresAt = Date.now() + days * 24 * 60 * 60 * 1000;
        window.localStorage.setItem(this.storageKey, String(expiresAt));
      } catch {
        return;
      }
    }
  }

  if (!customElements.get('welcome-offer')) {
    customElements.define('welcome-offer', WelcomeOffer);
  }

  } catch(e) { console.error(e); }
})();
})();
